import { render, staticRenderFns } from "./formView.vue?vue&type=template&id=c1b0498c&"
import script from "./formView.vue?vue&type=script&lang=js&"
export * from "./formView.vue?vue&type=script&lang=js&"
import style0 from "./formView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\新动态表单\\hj-dynamic-form-plugin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c1b0498c')) {
      api.createRecord('c1b0498c', component.options)
    } else {
      api.reload('c1b0498c', component.options)
    }
    module.hot.accept("./formView.vue?vue&type=template&id=c1b0498c&", function () {
      api.rerender('c1b0498c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/formView/src/formView.vue"
export default component.exports